module.exports = __webpack_public_path__ + "static/img/xwqpf.d0d8596.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xwqpf.png
// module id = tHwq
// module chunks = 0